// assets/infinite-scroll.js
// Handles infinite scrolling for product grid

document.addEventListener('DOMContentLoaded', function () {
  var infiniteScrollData = document.getElementById('infinite-scroll-data');
  if (!infiniteScrollData) return;

  var currentPage = parseInt(infiniteScrollData.getAttribute('data-current-page'), 10);
  var totalPages = parseInt(infiniteScrollData.getAttribute('data-total-pages'), 10);
  var baseUrl = infiniteScrollData.getAttribute('data-base-url');
  var sectionId = infiniteScrollData.getAttribute('data-section-id');
  var loading = false;
  var endReached = false;

  var productGrid = document.getElementById('product-grid');
  var loadingEl = document.querySelector('.infinite-scroll-loading');
  var endEl = document.querySelector('.infinite-scroll-end');
  var triggerEl = document.querySelector('.infinite-scroll-trigger');

  function showLoading() {
    if (loadingEl) loadingEl.style.display = 'flex';
  }
  function hideLoading() {
    if (loadingEl) loadingEl.style.display = 'none';
  }
  function showEnd() {
    if (endEl) endEl.style.display = 'block';
  }
  function loadNextPage() {
    if (loading || endReached || currentPage >= totalPages) return;
    loading = true;
    showLoading();
    var nextPage = currentPage + 1;
    var url = baseUrl + '?page=' + nextPage + '&section_id=' + sectionId;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newProducts = doc.querySelectorAll('#product-grid > li');
        newProducts.forEach(function (li) {
          productGrid.appendChild(li);
        });
        currentPage = nextPage;
        if (currentPage >= totalPages) {
          endReached = true;
          showEnd();
        }
        hideLoading();
        loading = false;
      })
      .catch(function () {
        hideLoading();
        loading = false;
      });
  }


  // Alternative to IntersectionObserver: scroll event listener
  function isNearBottom() {
    // Distance from bottom in pixels to trigger loading
    var threshold = 300;
    var scrollY = window.scrollY || window.pageYOffset;
    var viewportHeight = window.innerHeight;
    var gridRect = productGrid.getBoundingClientRect();
    var gridBottom = gridRect.bottom + scrollY;
    return (scrollY + viewportHeight + threshold) >= gridBottom;
  }

  window.addEventListener('scroll', function () {
    if (isNearBottom()) {
      loadNextPage();
    }
  });
});
